import { ThemeDefinition } from 'vuetify';

// example coloring extended from light colors
export const light: ThemeDefinition = {
  dark: false,
  colors: {},
};

// example coloring extended from dark colors
export const dark: ThemeDefinition = {
  dark: true,
  colors: {},
};
